import './App.css';
import { useState } from 'react';
import OCR from './OCR';

function App() {
  const handleClick = () => {

  }

  return (
    <div className="App">
      <header className="App-header">
        {{OCR}}
      </header>
    </div>
  );
}

export default App;
